import { Model } from 'modules/core/lib/mobx-rest'

interface ISupplementObservation {
  [key: string]: any
}

class SupplementObservation extends Model<ISupplementObservation> {
  static urlRoot() {
    return '/payroll/supplements_observation'
  }
}

export default SupplementObservation
